'use strict';

var util = require('../../util');

var alterUpsell = {};

alterUpsell.init = function () {
    // trigger expirience only for alternative impulse upsell session
    if (window.og_settings && window.og_settings.alternative_impulse_upsell && $('#impulse-upsell-container').length) {
        var pidParam = {
            pid: $('#pid').val()
        };
        var loadContentUrl = util.appendParamsToUrl(Urls.alterUpsellContent, pidParam);
        $('#impulse-upsell-container').load(loadContentUrl);
        $('.og-offer').hide();

        $('#product-content').on('click', '.offer-heading', function () {
            // expand content
            $(this).parents('.upsell-offer').toggleClass('expanded');
        });

        $('#product-content').on('click', '#og-upsell-button', function (e) {
            e.preventDefault();
            var productId = $('#pid').val();
            var qty = $('input[name="Quantity"]').val();
            var offerOption = $('[name="offer-option"]:checked').attr('id');
            var everyPeriod = '';
            var every = '';
            var newSubscription = false;
            if (offerOption === 'offer-subscribe') {
                var offerPeriodArray = $('.offer-delivery [name="frequency"]').val().split('_');
                every = offerPeriodArray[0];
                everyPeriod = offerPeriodArray[1];
                newSubscription = true;
            }
            var params = {
                format: 'ajax',
                productId: productId,
                qty: qty,
                newSubscription: newSubscription,
                every: every,
                everyPeriod: everyPeriod
            };
            var url = util.appendParamsToUrl(Urls.addUpsellItem, params);
            $.ajax({
                type: 'Get',
                url: url
            }).done(function (resonse) {
                $('.upsell-offer').hide();
                if (resonse.status === 'OK') {
                    $('.success-message').show();
                } else {
                    $('.error-content').show();
                }
            });
        });
    }
};

module.exports = alterUpsell;
